import { Component, Input, OnInit, EventEmitter, Output, ViewEncapsulation, ViewChild, ElementRef, NgZone, QueryList, AfterViewInit, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';


import { InfoModalComponent } from '../popup-modals/info-modal/info-modal.component';
import { CameraComponent } from '../camera/camera.component';
import { DocUploadService } from '../../services/doc-upload.service';
import { Helper } from '../../utitlity/helper';
import { HttpEvent } from '@angular/common/http';

declare var $: any;
@Component({
    selector: 'form-doc-upload-popup',
    template: require('./form-doc-upload-popup.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    styles: [require('./form-doc-upload-popup.component.css')],
    providers: [DocUploadService],
    encapsulation: ViewEncapsulation.None,
})
export class FormDocUploadPopupComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() docUploadData: any;

    @ViewChild('rootEle') rootRef: ElementRef;
    @ViewChild('fileUploadEle') fileUploadEle: ElementRef;
    @ViewChildren(CameraComponent) camera: QueryList<CameraComponent>;
    currentSliderIndex: string;
    currentCamera: CameraComponent;
    cameraList: CameraComponent[];
    currentTabIndex: any;
    @Output() documentActionEmit: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('docOverviewModal') docOverviewModal: InfoModalComponent;
    @Output() onChildClick: EventEmitter<string> = new EventEmitter<string>();
    file: any;
    selectOptionIndexFlag = false;
    selectedIdx: any;
    documentSelected: any;
    docIndex: any;
    selectedIndex: any;
    selectOptionIndex: any = [];
    indexToAppendClassTo: any[] = [];
    indexToAppendErrorClassTo: any[] = [];
    indexToAppendDeleteButton: any[] = [];
    indexToAppendClassToDelete: any[] = [];
    indexToAppendMessageTo: any[] = [];
    selectedRow: Number;
    actionResponse: any = [];
    isUploadBtn = false;
    isSelectUploadBtn = true;
    btnDefaultClass = true;
    docDropDefault: boolean = true;
    docDisableDefault: boolean = true;
    appRefNo: any;
    deletedIndex: any;
    errorClass = false;
    deskCam: boolean = false;
    mobileView: boolean = false;
    openCamera: boolean = false;
    successMsg: any;
    hasCam: any;
    dcmessage:any;
    docPreviewPopup = {
        message: '',
    }
    docUploadDropdown = {

    }
    isFileIndexes(files) {
        let mappedFiles = [];
        if (files) {
            mappedFiles = files.map(file => file.index)
        }
        return mappedFiles.indexOf(this.currentSliderIndex) == -1;
    }

    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor(private zone: NgZone,
        private docService: DocUploadService,
    ) { }
    show() {
        $(this.rootRef.nativeElement).modal('show');
    }

    hide() {
        $(this.rootRef.nativeElement).modal('hide');
    }

    openFileUpload(index, visaType) {

        $('#fileUploadEle' + index).click();
    }
    documentSelect(event: any, index: any, hasCamera?: any) {
        this.hasCam = hasCamera;
        this.resetActionResponse(index);
        this.docUploadData.message = '';
        let file = hasCamera ? event : event.srcElement.files[0];

        this.selectedRow = index;
        this.docUploadData.isValid = false;
        this.docUploadData.message = '';
        this.errorClass = false;
        if (file) {
            this.docUploadData.isValid = true;
            this.errorClass = true;
            this.docUploadData.message = this.docService.checkForDocUploadErr(file);
            if (this.docUploadData.message.length > 0) {
                if (this.selectOptionIndexFlag == true) {
                    this.docUploadData.docRec[index].docInfo[this.selectOptionIndex[index]].files = [];
                }
                else {
                    this.docUploadData.docRec[index].docInfo[0].files = [];
                }
                return;
            }
            else {
                this.docUploadData.message = '';
                this.docUploadData.isValid = false;
                this.errorClass = false;
            }

        }
        if (this.selectOptionIndexFlag == true) {
            this.docUploadData.docRec[index].docInfo[this.selectOptionIndex[index]].files = hasCamera ? event : event.srcElement.files[0];;

            this.docUploadData.docRec[index].documentSelected = this.docUploadData.docRec[index].docInfo[this.selectOptionIndex[index]];
            this.documentSelected = this.docUploadData.docRec[index].documentSelected;
            this.docIndex = this.docUploadData.docRec[index].documentSelected.docIndex[0].index;
            this.selectedIndex = index;

            let param = {
                docObj: this.docUploadData.docRec[index].docInfo[this.selectOptionIndex[index]].files,
                documentSelected: this.documentSelected,
                docIndex: this.docIndex,
            }

            Helper.enableSpinner(true);
            // this.docUploadData.message = 'Document Selected, Please Click the Upload';
            this.actionResponse[index] = {
                message: 'Document is selected, please click on upload'
            }
            this.isUploadBtn = true;
        } else {
            this.selectOptionIndexFlag = false;
            this.selectOptionIndex = false;
            this.docUploadData.docRec[index].docInfo[0].files = hasCamera ? event : event.srcElement.files[0];;

            this.documentSelected = this.docUploadData.docRec[index].documentSelected;
            if (this.documentSelected) {
                // this.docUploadService.renderFile(file, this.documentSelected,hasCamera);
            }
            if (this.documentSelected == undefined) {
                this.docUploadData.message = 'Please select the type of document to Upload';
                this.isUploadBtn = false;
                //this.indexToAppendClassToDelete.push(this.selectedRow);
            } else {
                this.docIndex = this.docUploadData.docRec[index].documentSelected.docIndex[0].index;
                this.selectedIndex = index;
                let param = {
                    docObj: this.docUploadData.docRec[index].docInfo[0].files,
                    documentSelected: this.documentSelected,
                    docIndex: this.docIndex,
                }
                Helper.enableSpinner(false);
                // this.docUploadData.message = 'Document Selected, Please Click the Upload';
                this.actionResponse[index] = {
                    message: 'Document is selected, please click on upload'
                }
                this.isUploadBtn = true;
            }
        }
    }
    hasDocumentSelected(index: any) {
        let docInfoIndex;
        (!this.selectOptionIndex) ? docInfoIndex = 0 : docInfoIndex = this.selectOptionIndex[index];
        (this.docUploadData.docRec[index].docInfo.length > 1) ? null : docInfoIndex = 0;
        if (this.docUploadData.docRec[index].docInfo[docInfoIndex].files.length == 0) {
          return false;
        }
        return true;
      }
    docCameraPreview(id1) {
        let index = 0;
        let arr = [1, 2, 3].filter(function (item) { return item != id1 });
        if (arr.length < 3) {
            let ele1 = document.getElementById('popover__wrapper1');
            if (ele1)
                ele1.style.display = "none";

            let ele2 = document.getElementById('popover__wrapper2');
            if (ele2)
                ele2.style.display = "none";

            let ele3 = document.getElementById('popover__wrapper3');
            if (ele3)
                ele3.style.display = "none";
        }
        let ele = document.getElementById('popover__wrapper' + id1);
        ele.style.display = "block";

        this.currentCamera = this.cameraList[index]
        if (this.currentTabIndex == index) {
            this.currentTabIndex = '-1'
            this.currentCamera.closeCamera();
            return;
        }
        if (this.cameraList[this.currentTabIndex])
            this.cameraList[this.currentTabIndex].closeCamera();

        this.currentTabIndex = index;
        this.cameraList[index].loadCamera();
    }
    ngOnInit() {
        console.log("input", this.docUploadData);

    }


    ngAfterViewInit() {


    }




    onChange(event) {

        this.file = event.srcElement.files[0];
        if (this.docUploadData.docInfo) {
            this.docService.renderFile(this.file, this.docUploadData.docInfo);
        }
    }



    ngOnChanges(changes: SimpleChanges): void {


    }




    documentAction(type: any, index: any, e: Event) {
        let docInfoIndex;
        this.selectedRow = index;
        //console.log(this.docUploadData.docRec[index].docInfo);

        switch (type) {
            case 'upload':
                (!this.selectOptionIndex) ? docInfoIndex = 0 : docInfoIndex = this.selectOptionIndex[index];
                (this.docUploadData.docRec[index].docInfo.length > 1) ? null : docInfoIndex = 0;
                let param = {
                    type: type,
                    docObj: this.docUploadData.docRec[index].docInfo[docInfoIndex].files,
                    documentSelected: this.docUploadData.docRec[index].documentSelected,
                    docIndex: this.docUploadData.docRec[index].documentSelected.docIndex[0].index,
                }
                //  
                Helper.enableSpinner(true);
                this.resetActionResponse(index);
                
                this.isUploadBtn = false;
                this.isSelectUploadBtn = false;
              // this.documentActionEmit.emit(param);
              this.uploadDocument(param,index);
             
              break;
            case 'delete':
                this.docDisableDefault = false;
                Helper.enableSpinner(true);
                this.deletedIndex = index;
                this.resetActionResponse(index);
                this.docUploadData.message = 'Deleting the Document...';
                this.reset(this.deletedIndex);
        }
    }


  
  
    resetActionResponse(index: any) {
        this.actionResponse[index] = {
            message: ''
        };
    }
    reset(index: any) {
        var removeIndex = index;
        // this.mySelectedFile.nativeElement.value = '';
        this.docUploadData.message = 'Document Deleted';
        this.indexToAppendErrorClassTo.push(removeIndex);
        this.indexToAppendClassToDelete.push(removeIndex);
        this.indexToAppendClassTo = this.indexToAppendClassTo.filter(item => item !== removeIndex);
        this.errorClass = true;
        this.indexToAppendDeleteButton = this.indexToAppendDeleteButton.filter(item => item !== removeIndex);
        this.isSelectUploadBtn = true;
        this.isUploadBtn = false;
        this.removeFile(index);
        Helper.enableSpinner(false);
    }
    removeFile(index: any) {
        // console.log(this.docUploadData);
        this.docUploadData.docRec[index].docInfo.map((t: any) => {
            t.uploadedFiles = [];
            t.files = [];
            let toDefault = {
                "index": t.docIndex[0].index,
                "fileContent": t.docIndex[0].fileContent,
                "fileNetId": null,
                "fileName": null
            }
            t.docIndex = [];
            t.docIndex.push(toDefault);
        });
        
        this.docDropDefault = false;

        let param = {
            index: index
        }
        this.documentActionEmit.emit(param);
       
    }
    uploadDocument(documentObj,index) {
        let fileObj;
        //Helper.enableSpinner(true);
        if (documentObj.docObj) {
          fileObj = documentObj.docObj;
        }
        else if (documentObj.documentSelected && documentObj.documentSelected.files.length > 0) {
          fileObj = documentObj.documentSelected.files[0].file;
        }
        let fileName: string = documentObj.docObj ? documentObj.docObj.name : documentObj.documentSelected && documentObj.documentSelected.files[0].fileName;
        let param = {
          file: fileObj,
          mapAsJson: {
            docCode: documentObj.documentSelected.docCode,
            docName: fileName,
            arnNo:'21687535438485116',//this.appRef,//'21687535438485116',//this.applicationData.appRefNumber,
            docIndex: documentObj.docIndex
          }
        }
        let formData = new FormData();
        formData.append('file', param.file);
        formData.append('mapAsJson', JSON.stringify(param.mapAsJson));
        //this.uploadSuccesful = false;
        this.docService.uploadDocument(formData)
          .then(() => {
     
        this.successMsg = this.docService.getDocUploadApiMessage('Document Upload is successful.', 'success');
        this.docUploadData.message = this.successMsg[0];
        this.docUploadData.messageType = this.successMsg[1];
           
         
           // this.docService.clearDocUploadMsg(documentObj.documentSelected);
            
          //  this.uploadSuccesful = true;        
            Helper.enableSpinner(false);
    
          }, (err) => {
            //.documentSelected.docUploadMsg = this.docService.getDocUploadApiMessage('Document Upload failed.', 'danger');
            this.docService.clearDocUploadMsg(documentObj.documentSelected);
    
            Helper.enableSpinner(false)
    
          })
      }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/form-doc-upload-popup/form-doc-upload-popup.component.ts